export default {
  'acc103.action.SAVE': 'Save',
  'acc103.action.ATTACH': 'Attach original',
  'acc103.action.VOID': 'Void',
  'acc103.status.CONFIRMED': 'Included',
  'acc103.title': 'Expense Receipts',
  'acc103.month': 'Receipt month',
  'acc103.merchant': 'Merchant',
  'acc103.receiptDate': 'Receipt date',
  'acc103.receiptNumber': 'Receipt number',
  'acc103.currency': 'Original currency',
  'acc103.grossAmount': 'Original gross amount',
  'acc103.taxAmount': 'Original tax',
  'acc103.remarks': 'Notes',
  'acc103.duplicateReason': 'Reason for duplicate registration',
  'acc103.linkMode': 'Link mode',
  'acc103.sourceMonth': 'Expense / budget month',
  'acc103.cashEntryId': 'Existing manual expense',
  'acc103.fixedCode': 'Fixed expense',
  'acc103.paidDate': 'Actual payment date',
  'acc103.paidJpy': 'JPY amount paid',
  'acc103.status': 'Status',
  'acc103.actions': 'Actions',
  'acc103.reload': 'Reload',
  'acc103.new': 'New receipt',
  'acc103.edit': 'Edit',
  'acc103.view': 'View',
  'acc103.void': 'Void',
  'acc103.close': 'Close',
  'acc103.history': 'Change history',
  'acc103.actor': 'Actor',
  'acc103.saveDraft': 'Save draft',
  'acc103.saveLink': 'Save and link',
  'acc103.saved': 'Saved',
  'acc103.openOriginal': 'Open original group',
  'acc103.camera': 'Take photo',
  'acc103.upload': 'Gallery / file',
  'acc103.fileHint':
    'JPEG / PNG / WebP / PDF, up to 10MB per file and 10 PDF pages. One receipt per group; attachments do not create extra expenses.',
  'acc103.preview': 'Original preview',
  'acc103.previewFailed': 'Unable to load the original. Select the attachment again to retry.',
  'acc103.noFile': 'Select or upload an original',
  'acc103.aiNotice':
    'Selected originals will be sent to MiniMax China. Review the extracted data before saving; AI never books expenses. Continue?',
  'acc103.aiDisabled':
    'AI is not configured or has not passed a real image test. Manual entry, drafts and linking remain available.',
  'acc103.recognize': 'AI extract / retry',
  'acc103.pages': 'Pages processed',
  'acc103.applyWarning': 'Apply extracted fields? Check amounts, dates and multiple tax rates.',
  'acc103.apply': 'Apply extracted fields',
  'acc103.stale':
    'The draft or form changed. Save and extract again to avoid overwriting manual changes.',
  'acc103.currencyHint': 'Use a three-letter uppercase currency code, e.g. JPY or USD.',
  'acc103.duplicateHint':
    'For duplicates, add files to the original group; explain why a new registration is necessary.',
  'acc103.link': 'Expense linkage',
  'acc103.budget': 'Existing budget',
  'acc103.difference': 'Receipt / budget difference',
  'acc103.budgetHint': 'Evidence only: does not replace the budget or create another expense.',
  'acc103.syncPayment':
    'Also update the linked payment date and amount (affects reports and cash projections)',
  'acc103.linkedPayment': 'Current linked payment',
  'acc103.paymentHint':
    'New expenses require the actual date and JPY payment. Save a draft if incomplete. Original tax is evidence only.',
  'acc103.voidWarning': 'Void only this receipt? The expense and payment will not be cancelled.',
  'acc103.mode.NEW': 'New expense',
  'acc103.mode.EXISTING': 'Link manual expense',
  'acc103.mode.FIXED': 'Link fixed budget',
  'acc103.status.DRAFT': 'Draft',
  'acc103.status.REGISTERED': 'Registered',
  'acc103.status.VOID': 'Void',
  'acc103.status.QUEUED': 'Queued',
  'acc103.status.RUNNING': 'Extracting',
  'acc103.status.SUCCEEDED': 'Extracted',
  'acc103.status.FAILED': 'Failed',
  'acc103.error.FAILED': 'Unable to complete. Your input is retained; check and retry.',
  'acc103.error.INVALID': 'Check the fields, dates and amounts.',
  'acc103.error.CONFLICT': 'The record changed. Reopen it and review the latest data.',
  'acc103.error.DUPLICATE':
    'Duplicate file or possible duplicate receipt. Open its original group or provide a new-registration reason.',
  'acc103.error.NOT_FOUND': 'Record not found or unavailable.',
  'acc103.error.REGISTER_REQUIRED': 'Use Save and link for registered receipts.',
  'acc103.error.PAYMENT_REQUIRED': 'Enter the actual payment date and JPY amount, or save a draft.',
  'acc103.error.SYNC_REQUIRED': 'Review the payment and explicitly enable synchronization.',
  'acc103.error.PAYMENT_INVALID': 'Check the payment date, amount and version.',
  'acc103.error.FILE_LIMIT': 'File must be nonempty and at most 10MB.',
  'acc103.error.FILE_TYPE': 'Content is not a valid JPEG, PNG, WebP or PDF.',
  'acc103.error.PDF_LIMIT': 'PDF must be unencrypted and at most 10 pages.',
  'acc103.error.IMAGE_LIMIT': 'Image dimensions are too large. Resize before uploading.',
  'acc103.error.ATTACHMENT_LIMIT': 'At most 10 attachments and 20 total pages per group.',
  'acc103.error.AI_DISABLED':
    'AI is disabled. Enter manually or ask an administrator to finish image verification.',
  'acc103.error.CONSENT_REQUIRED': 'Explicit consent is required before sending.',
  'acc103.error.AI_LIMIT': 'Subscription quota or rate limit reached. Retry manually later.',
  'acc103.error.AI_ACCESS': 'Subscription key lacks access. Ask an administrator to check.',
  'acc103.error.AI_TIMEOUT':
    'Recognition timed out or network unavailable. Original retained; retry manually.',
  'acc103.error.AI_FAILED': 'Recognition failed. Original retained; enter manually or retry.',
  'acc103.error.AI_INVALID': 'Invalid or incomplete extraction. Review manually and retry.',
  'acc103.error.INTERRUPTED':
    'Previous recognition was interrupted, not automatically retried. Review and retry manually.',
  'acc103.expenseName': 'Expense name',
  'menu.accounting.expense-invoices': 'Expense Receipts',
};
